const onlyNumbers = /^[0-9]+$/;
const invoiceNumber = /^[A-Za-z0-9\/\-]+$/


const regularExpressions = {
    onlyNumbers,
    invoiceNumber
}

export { regularExpressions }